



















































































































































































import { mdiPlay, mdiDotsHorizontal, mdiScoreboard } from "@mdi/js";
import { Vue, Component, Ref } from "vue-property-decorator";
import { vxm } from "@/store";
import SlideshowControls from "@/components/slideshow/slideshow-controls.vue";
import { mediumImageStyle as getMediumImageStyle } from "@/domain/event-medium";

@Component({
  components: {
    "slideshow-controls": SlideshowControls
  },

  created() {
    vxm.results.setSlideshow(false);
  }
})
export default class SlideshowIndex extends Vue {
  @Ref("slideshowControls") slideshowControls!: SlideshowControls;

  showScores = false;
  mediumImageStyle = getMediumImageStyle;
  playIcon = mdiPlay;
  menuIcon = mdiDotsHorizontal;
  scoresIcon = mdiScoreboard;

  get game() {
    return vxm.results.game;
  }

  get media() {
    return vxm.results.media;
  }

  get medium() {
    return vxm.results.media[0];
  }

  get mediumIsSideways() {
    return !!this.medium && this.medium.rotation % 180 !== 0;
  }

  get teams() {
    const media = this.media;
    const teams = vxm.results.teams.map(team => ({
      ...team,
      photos: this.media.filter(medium => medium.teamId === team.id).length
    }));

    if (!this.showScores) {
      teams.sort((a, b) => {
        const aName = a.name.toUpperCase();
        const bName = b.name.toUpperCase();

        return aName < bName ? -1 : aName > bName ? 1 : 0;
      });
    }

    return teams;
  }

  startSlideshow() {
    this.slideshowControls.toggleSlideshow();
  }

  get publicStandings() {
    return vxm.results.game.publicResults.includes("statistics");
  }
}
